var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHouse = function SvgIconHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.35 4.75 10.94v8.311h4V15a1.75 1.75 0 0 1 1.75-1.75h3A1.75 1.75 0 0 1 15.25 15v4.25h4v-8.311zm-1.18-1.63a1.75 1.75 0 0 1 2.361.002l7.498 6.813.014.013a1.78 1.78 0 0 1 .557 1.264V19.5a1.75 1.75 0 0 1-1.75 1.75H15a1.75 1.75 0 0 1-1.75-1.75v-4.25h-2.5v4.25A1.75 1.75 0 0 1 9 21.25H4.5a1.75 1.75 0 0 1-1.75-1.75v-8.688a1.78 1.78 0 0 1 .557-1.264l.014-.013 7.498-6.813z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHouse;